import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useQueryClient,
} from "react-query";
import {
  getAccessLevelList,
  getAddNewAccess,
  getAddTargetUser,
  getAddTicket,
  getAllUsersRollCallList,
  getAnswerTicketByAdmin,
  getChangeDepartment,
  getCloseTicket,
  getDeleteAccessItem,
  getDeleteMeeting,
  getDeleteTarget,
  getDeleteTargetUser,
  getDepartementList,
  getEditAccessItem,
  getEditTarget,
  getEditTargetUser,
  getInsertLeaveReq,
  getInsertMeetingSummary,
  getInsertNewTarget,
  getLeaveReqAdminList,
  getLeaveReqList,
  getMeetingList,
  getReferTicket,
  getSingleLeaveReq,
  getSingleTarget,
  getTargetList,
  getTicketsChat,
  getTicketsList,
  getUpdateMeetingSummary,
  getUserRollCall,
  sendNotifUpdateProduct,
  setRollCall,
} from "../services/management";
import { errorMessage, successMessage } from "../utils/message";

export const useGetMeetingList = () => useQuery("meeting-list", getMeetingList);

export const useInsertMettingSummary = () => {
  const queryClient = useQueryClient();

  return useMutation(getInsertMeetingSummary, {
    onSuccess: () => {
      successMessage("صورت جلسه با موفقیت ذخیره شد");
      queryClient.invalidateQueries("meeting-list");
    },
    onError: () => {
      errorMessage("فیلد های خالی را پر کنید");
    },
  });
};

export const useUpdateMeetingSummary = () => {
  const queryClient = useQueryClient();

  return useMutation(getUpdateMeetingSummary, {
    onSuccess: () => {
      successMessage("صورت جلسه با موفقیت آپدیت شد");
      queryClient.invalidateQueries("meeting-list");
    },
    onError: () => {
      errorMessage("عملیات با خطا مواجه شد");
    },
  });
};

export const useDeleteMeetingSummary = () => {
  const queryClient = useQueryClient();

  return useMutation(getDeleteMeeting, {
    onSuccess: () => {
      successMessage("حذف صورت جلسه با موفقیت انجام شد");
      queryClient.invalidateQueries("meeting-list");
    },
    onError: () => {
      errorMessage("عملیات حذف با خطا مواجه شد");
    },
  });
};

export const useGetTicketsList = (key) =>
  useInfiniteQuery(
    ["tickets-list", key],
    ({ pageParam = 1 }) => getTicketsList(key, pageParam),
    {
      getNextPageParam: (lastPage, allPages) => {
        return allPages.length + 1;
      },
    }
  );
// export const useFilterTickets = () => {
//   const queryClient = useQueryClient();
//   return useMutation(getTicketsList, {
//     onSuccess: () => {
//       // queryClient.invalidateQueries("tickets-list");
//     },
//   });
// };

export const useGetTicketsChat = (data) =>
  useQuery("tickets-chat", () => getTicketsChat(data));

export const useAnswerTicketByAdmin = () => {
  const queryClient = useQueryClient();
  return useMutation(getAnswerTicketByAdmin, {
    onSuccess: () => {
      queryClient.invalidateQueries("tickets-chat");
      queryClient.invalidateQueries("tickets-number");
    },
    onError: () => {
      errorMessage("خطا در ارسال تیکت");
    },
  });
};
export const useAddTicket = () => {
  return useMutation(getAddTicket, {
    onSuccess: () => {
      successMessage("تیکت با موفقیت ارسال شد");
    },
    onError: () => {
      errorMessage("ارسال تیکت با خطا مواجه شد");
    },
  });
};
export const useGetDepartementList = () =>
  useQuery("departement-list", getDepartementList, {});

export const useChangeDepartment = () => {
  return useMutation(getChangeDepartment, {
    onSuccess: () => {
      successMessage("دپارتمان با موفقیت تغییر کرد");
    },
    onError: () => {
      errorMessage("امکان تغییر دپارتمان وجود ندارد");
    },
  });
};

export const useCloseTicket = () => {
  return useMutation(getCloseTicket, {
    onSuccess: () => {
      successMessage("تیکت با موفقیت بسته شد");
    },
    onError: () => {
      errorMessage("خطا در بستن تیکت");
    },
  });
};

export const useReferTicket = () => {
  return useMutation(getReferTicket, {
    onSuccess: () => {
      successMessage("تیکت با موفقیت ارجاع داده شد");
    },
    onError: () => {
      errorMessage("ارجاع تیکت با خطا مواجه شد");
    },
  });
};

// export const useGetAllUsersRollCallList = (data) =>
//   useQuery(["roll-call-all-users-list", data], () =>
//     getAllUsersRollCallList(data)
//   );
export const useGetAllUsersRollCallList = ({ search }) =>
  useInfiniteQuery(
    ["roll-call-all-users-list", search],
    ({ pageParam = 1 }) => getAllUsersRollCallList({ page: pageParam, search }),
    {
      getNextPageParam: (lastPage, allPages) => {
        return allPages.length + 1;
      },
    }
  );

export const useSetRollCall = (data) => {
  const queryClient = useQueryClient();
  return useMutation(setRollCall, {
    onSuccess: () => {
      queryClient.invalidateQueries("roll-call-all-users-list");
      successMessage("عملیات با موفقیت انجام شد");
    },
    onError: () => {
      errorMessage("عملیات با خطا مواجه شد");
    },
  });
};

export const useGetUserRollCallList = (data) =>
  useQuery(["user-roll-call-list", data], () => getUserRollCall(data));

export const useGetTargetList = () => useQuery("target-list", getTargetList);

export const useInsertNewTarget = () => {
  const queryClient = useQueryClient();
  return useMutation(getInsertNewTarget, {
    onSuccess: () => {
      queryClient.invalidateQueries("target-list");
      successMessage("تارگت با موفقیت اضافه شد");
    },
    onError: () => {
      errorMessage("عملیات با خطا مواجه شد");
    },
  });
};

export const useDeleteTarget = () => {
  const queryClient = useQueryClient();
  return useMutation(getDeleteTarget, {
    onSuccess: () => {
      queryClient.invalidateQueries("target-list");
      successMessage("تارگت با موفقیت حذف شد");
    },
    onError: () => {
      errorMessage("عملیات با خطا مواجه شد");
    },
  });
};
export const useEditTarget = () => {
  const queryClient = useQueryClient();
  return useMutation(getEditTarget, {
    onSuccess: () => {
      queryClient.invalidateQueries("target-list");
      queryClient.invalidateQueries("single-target");
      successMessage("تارگت با موفقیت ویرایش شد");
    },
    onError: () => {
      errorMessage("عملیات با خطا مواجه شد");
    },
  });
};

export const useSingleTarget = (id) =>
  useQuery(["single-target", id], () => getSingleTarget(id));

export const useAddTargetUser = () => {
  const queryClient = useQueryClient();
  return useMutation(getAddTargetUser, {
    onSuccess: () => {
      queryClient.invalidateQueries("single-target");
      successMessage("عضو تارگت با موفقیت افزوده شد");
    },
    onError: () => {
      errorMessage("عملیات با خطا مواجه شد");
    },
  });
};

export const useEditTargetUser = () => {
  const queryClient = useQueryClient();
  return useMutation(getEditTargetUser, {
    onSuccess: () => {
      queryClient.invalidateQueries("single-target");
      successMessage("ویرایش با موفقیت انجام شد");
    },
    onError: () => {
      errorMessage("عملیات با خطا مواجه شد");
    },
  });
};

export const useDeleteTargetUser = () => {
  const queryClient = useQueryClient();
  return useMutation(getDeleteTargetUser, {
    onSuccess: () => {
      queryClient.invalidateQueries("single-target");
      successMessage("عملیات با موفقیت انجام شد");
    },
    onError: () => {
      errorMessage("عملیات با خطا مواجه شد");
    },
  });
};

export const useSendNotifUpdateProduct = () => {
  const queryClient = useQueryClient();
  return useMutation(sendNotifUpdateProduct, {
    onSuccess: () => {
      queryClient.invalidateQueries("detail-online-order");
      successMessage("عملیات با موفقیت انجام شد");
    },
    onError: () => {
      errorMessage("عملیات با خطا مواجه شد");
    },
  });
};

export const useInsertLeaveReq = () => {
  const queryClient = useQueryClient();
  return useMutation(getInsertLeaveReq, {
    onSuccess: () => {
      queryClient.invalidateQueries("leave-req");
      successMessage("درخواست با موفقیت ثبت شد");
    },
    onError: () => {
      errorMessage("عملیات با خطا مواجه شد");
    },
  });
};

export const useGetLeaveReq = () => useQuery("leave-req", getLeaveReqList);

export const useGetLeaveReqAdminList = () =>
  useQuery("leave-req-admin-list", getLeaveReqAdminList);

export const useGetSingleLeaveReq = (data) =>
  useQuery(["single-leave-req", data], () => getSingleLeaveReq(data));

export const useGetAccessLevelList = () =>
  useQuery("access-level", getAccessLevelList);

export const useAddAccessLevel = () => {
  const queryClient = useQueryClient();
  return useMutation(getAddNewAccess, {
    onSuccess: () => {
      queryClient.invalidateQueries("access-level");
      successMessage("کاربر جدید افزوده شد");
    },
    onError: () => {
      errorMessage("عملیات با خطا مواجه شد");
    },
  });
};

export const useDeleteAccessItem = () => {
  const queryClient = useQueryClient();
  return useMutation(getDeleteAccessItem, {
    onSuccess: () => {
      queryClient.invalidateQueries("access-level");
      successMessage("کاربر با موفقیت حذف شد");
    },
    onError: () => {
      errorMessage("عملیات با خطا مواجه شد");
    },
  });
};

export const useGetEditAccessItem = () => {
  const queryClient = useQueryClient();
  return useMutation(getEditAccessItem, {
    onSuccess: () => {
      queryClient.invalidateQueries("access-level");
      successMessage("کاربر با موفقیت ویرایش شد");
    },
    onError: () => {
      errorMessage("عملیات با خطا مواجه شد");
    },
  });
};
